import { Build, Step } from "~/components/build/Show/lib/types";
import { QueryClient, queryOptions, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";

export const stepQueryKey = (build: Build, stepUuid: Step["uuid"]) => {
  return ["build", build.id, "steps", stepUuid];
};

export const stepQueryOptions = (
  build: Build,
  stepUuid: Step["uuid"],
  queryOptionsArgs: Omit<UseQueryOptions<Step>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: stepQueryKey(build, stepUuid),
    queryFn: ({ signal }) => fetchStep(build.buildDataBasePath, stepUuid, signal),
    ...queryOptionsArgs,
  });
};

export const setStepQueryData = (build: Build, step: Step, queryClient: QueryClient) => {
  queryClient.setQueryData(stepQueryKey(build, step.uuid), step);
};

function fetchStep(
  buildDataBasePath: Build["buildDataBasePath"],
  stepUuid: Step["uuid"],
  signal: AbortSignal,
): Promise<Step> {
  const url = new URL(`${buildDataBasePath}/steps/${stepUuid}`, window.location.origin);

  return fetcher(url, true, { signal });
}
